/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SettingControllerGetSettlementConfig$Params {
}

export function settingControllerGetSettlementConfig(http: HttpClient, rootUrl: string, params?: SettingControllerGetSettlementConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * 두당 사육관리비 (원)
 */
'farmManagementFeePerPig'?: number;

/**
 * 공모 수수료율 (예: 0.015 = 1.5%)
 */
'offeringFeeRate'?: number;

/**
 * 초과수익 수수료율 (예: 0.38 = 38%)
 */
'excessProfitFeeRate'?: number;

/**
 * 기준 수익률 (예: 0.11 = 11%)
 */
'excessProfitThreshold'?: number;

/**
 * 소득세율 (예: 0.14 = 14%)
 */
'incomeTaxRate'?: number;

/**
 * 지방소득세율 (예: 0.014 = 1.4%)
 */
'localTaxRate'?: number;
}>> {
  const rb = new RequestBuilder(rootUrl, settingControllerGetSettlementConfig.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * 두당 사육관리비 (원)
       */
      'farmManagementFeePerPig'?: number;
      
      /**
       * 공모 수수료율 (예: 0.015 = 1.5%)
       */
      'offeringFeeRate'?: number;
      
      /**
       * 초과수익 수수료율 (예: 0.38 = 38%)
       */
      'excessProfitFeeRate'?: number;
      
      /**
       * 기준 수익률 (예: 0.11 = 11%)
       */
      'excessProfitThreshold'?: number;
      
      /**
       * 소득세율 (예: 0.14 = 14%)
       */
      'incomeTaxRate'?: number;
      
      /**
       * 지방소득세율 (예: 0.014 = 1.4%)
       */
      'localTaxRate'?: number;
      }>;
    })
  );
}

settingControllerGetSettlementConfig.PATH = '/api/setting/settlement-config';
